
import axios from 'axios';
import config from '../config';
import { v4 as uuidv4 } from 'uuid';
import { Buffer } from 'buffer';

const paymentGatewayUrl = config.payment_gateway.url;
const hostUrl = config.host_url;
const { code: currency } = config.branding.currency;
const countryCode = config.branding.countryCode;

const getProductPrice = (product: Product): number => {
  return product.price || product.unitPrice || 0
}

export const createCheckout = async (cart: Cart, buyer: User, shippingFee: number = 0, stock?: number) => {
    if (!config.payment_gateway.pub_api_key) {
        throw new Error('Incomplete API keys. Please check your payment gateway configuration.');
    }

    // Validate stock availability
    if (stock !== undefined && stock <= 0) {
        throw new Error('This product is out of stock.');
    }
    
    // Check if any item quantity exceeds available stock
    const cartQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
    if (stock !== undefined && cartQuantity > stock) {
        throw new Error(`Insufficient stock. Only ${stock} item(s) available.`);
    }

    const token = Buffer.from(`${config.payment_gateway.pub_api_key}:`, 'binary').toString('base64');
    const requestReferenceNumber = uuidv4();

     const req: CheckoutRequest = {
         totalAmount: {
             currency: currency,
             value: cart.totalAmount + shippingFee,
             details: {
                 subtotal: cart.totalAmount,
                 shippingFee: shippingFee
             }
         },
        items: cart.items.map((item): CheckoutItem => {
            const itemPrice = getProductPrice(item.product);
            return {
                amount: {
                    value: itemPrice,
                    details: {
                        subtotal: itemPrice
                    }
                },
                totalAmount: {
                    value: item.totalPrice
                },
                name: item.product.name,
                quantity: item.quantity
            }
        }),

        redirectUrl: {
            success: `${hostUrl}/purchase/success?id=${requestReferenceNumber}&shipping=${shippingFee}`,
            failure: `${hostUrl}/purchase/failed?id=${requestReferenceNumber}`,
            cancel: `${hostUrl}/purchase/canceled?id=${requestReferenceNumber}`
        },

        buyer: {
            firstName: buyer.firstName || "Customer",
            lastName: buyer.lastName || "",
            contact: {
                phone: buyer.phone || "",
                email: buyer.email || ""
            },
             shippingAddress: {
                 line1: buyer.address || "",
                 city: buyer.city || "",
                 state: buyer.province || "",
                 countryCode: countryCode,
                 shippingType: "ST"
             }
        },
        requestReferenceNumber
    }

    const headers = {
        accept: 'application/json',
        authorization: `Basic ${token}`,
        'content-type': 'application/json'
    }

    const response = await axios.post(`${paymentGatewayUrl}`, req, { headers });
    const checkout: CheckoutTransaction = response.data;

    return checkout;
}
